import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import Booking from 'models/booking';

const StubhubDisclaimer = ({ parkingPass, booking }) => {
  if (!get(booking, 'partner.isStubhub')) { return null; }

  return (
    <div>
      <div className="row hidden-print">
        <div className="col-xs-10 col-xs-offset-1">
          <hr className="ticket-section-break with-vertical-margin-2x" />
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1">
          <p className="text-weight-bold text-color-dark-slate">
            <FormattedMessage id="parking-pass.parkwhiz-price" defaultMessage="ParkWhiz Price" />
            <br />
            <span className="stubhub-disclaimer-price">
              ${parkingPass.pricePaid.toFixed(2)}
            </span>
          </p>
          <div className="text-weight-light text-color-slate">
            <p>
              <FormattedMessage
                id="parking-pass.book-directly"
                defaultMessage="Want the real inside track on event parking? Book directly{br}
                with ParkWhiz on our app or at {pwLink}.{br}
                No refunds for passes purchased through third party sellers."
                values={{
                  pwLink: <a href="https://www.parkwhiz.com">ParkWhiz.com</a>,
                  br: <br />,
                }}
              />
            </p>
            <p>
              <FormattedMessage
                id="parking-pass.stubhub-contact"
                defaultMessage="Need help using your parking pass? Call/text ParkWhiz at: {telLink}"
                values={{
                  telLink: (
                    <a
                      href="tel:+1-888-472-7594"
                      className="text-color-dark-slate text-weight-medium"
                    >
                      +1 (888) 472-7594
                    </a>
                  ),
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

StubhubDisclaimer.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  booking: PropTypes.instanceOf(Booking).isRequired,
};

export default StubhubDisclaimer;
